import { Dispatch, forwardRef, SetStateAction } from 'react';

import { FormProvider } from 'core/states';
import { IStepButtonOptions } from 'core/types';
import { IPart } from 'parts/types';
import { QuoteEntityType, QuoteType } from 'quotes/enums';
import { ICustomerQuote, ICustomerQuotePart, IQuotePart, IQuotePartLineForm } from 'quotes/types';
import { ITaxonomyGroup } from 'taxonomy/types';

import { LineDetailsFormWithProvider } from './LineDetailsFormWithProvider';
import { quotePartUpsertLineDetailsSchema } from './schema';

interface IProps {
  quoteId: number;
  quoteType?: QuoteType;
  quotePart: IQuotePart;
  isEdit: boolean;
  isOpen: boolean;
  onClose: () => void;
  isAlternateVersionEnabled?: boolean;
  entityType?: QuoteEntityType;
  setHasExternalTaxonomy?: Dispatch<SetStateAction<boolean>>;
  quote: ICustomerQuote;
  setValidatePartTaxonomyPath?: Dispatch<SetStateAction<ITaxonomyGroup[]>>;
  defaultValues: IQuotePartLineForm;
  onSubmit?: () => Promise<boolean>;
  saveAndAddNextOptions?: IStepButtonOptions;
  onValidatingChange?: (isValidating: boolean) => void;
  // A part chosen before the form opens (the Part Finder™ picks it): validated once on open,
  // as picking it in the part number field would, and locked in the form.
  initialPart?: Partial<IPart>;
}

export const LineDetails = forwardRef(function LineDetails(props: IProps, ref) {
  return (
    <FormProvider
      schema={quotePartUpsertLineDetailsSchema(
        props?.quoteType,
        props?.isAlternateVersionEnabled,
        props?.quotePart?.id ? (props.quotePart as ICustomerQuotePart) : null
      )}
      defaultValues={props?.defaultValues}
    >
      <LineDetailsFormWithProvider ref={ref} {...props} />
    </FormProvider>
  );
});
